import Api from "@/utils/api";

const state = {
  tenants: [],
  tenant_programs: [],
  tenant_program: {},
  tenant_courses: [],
  drafted_courses: [],
  tenant_course: {},
  tenant_modules: [],
  tenant_module: {},
  tenant_lesson: {},
  tenant_lessons: [],
  tenant_module_lessons: [],
  tenant_article: [],
  tenant: null,
  tenant_assets: [],
  resources: [],
  lesson_pool: [],
  quizzes: [],
  exercises: [],
  surveys: [],
  quizResults: [],
  surveyLearners: [],
  gamifications: [],
  tenant_learners : [],
  themeColor: "#2e3a6e",
  course_title:'',

  growth_plans: [],
  // themeColor: null,
  settings: {},
  tenant_testimonials: [],
  tenantLabels: [],
  tenantLabel: "",
  supportCurrentPage:null
};
const getters = {
  getSettings(state) {
    return state.settings;
  },
  getThemeColor(state) {
    return state.themeColor;
  },
  getTenants(state) {
    return state.tenants;
  },
  getTenantArticle(state) {
    return state.tenant_article;
  },
  getSurveyLearners(state) {
    return state.surveyLearners;
  },
  getQuizResults(state) {
    return state.quizResults;
  },
  getQuizzes(state) {
    return state.quizzes;
  },
  getExercises(state) {
    return state.exercises;
  },
  getTenantAsset(state) {
    return state.tenant_assets;
  },
  getTenantSurveys(state) {
    return state.surveys;
  },
  getTenant(state) {
    return state.tenant;
  },
  getTenantPrograms(state) {
    return state.tenant_programs;
  },
  getTenantProgram(state) {
    return state.tenant_program;
  },
  getTenantCourses(state) {
    return state.tenant_courses;
  },
  getTenantTestimonials(state) {
    return state.tenant_testimonials;
  },
  getTenantDraftedCourses(state) {
    return state.drafted_courses;
  },
  getTenantCourse(state) {
    return state.tenant_course;
  },
  getTenantModules(state) {
    return state.tenant_modules;
  },
  getResources(state) {
    return state.resources;
  },
  getTenantModule(state) {
    return state.tenant_module;
  },
  getTenantLessons(state) {
    return state.tenant_lessons;
  },
  getTenantLesson(state) {
    return state.tenant_lesson;
  },
  getTenantModuleLessons(state) {
    return state.tenant_module_lessons;
  },
  getLessonPool(state) {
    return state.lesson_pool;
  },
  getGrowthPlans(state) {
    return state.growth_plans;
  },
  getGamifications(state) {
    return state.gamifications;
  },
  fetchTenantLabels(state) {
    return state.tenantLabels;
  },
  fetchTenantLabel(state) {
    return state.tenantLabel;
  },

  getTenantLearners(state) {
    return state.tenant_learners;
  }
};
const mutations = {
  loadSettings(state, data) {
    state.settings = data;
  },
  setCourseTitle(state, data){
    state.course_title = data;
  },
  setThemeColor(state, color) {
    state.themeColor = color;
  },
  setGrowthPlans(state, color) {
    state.growth_plans = color;
  },
  setTenants(state, data) {
    return (state.tenants = data);
  },
  setTenantAsset(state, data) {
    return (state.tenant_assets = data);
  },
  addResource(state, data) {
    return (state.resources = state.resources.concat(data));
  },
  addLessonPool(state, data) {
    return (state.lesson_pool = state.lesson_pool.concat(data));
  },
  clearLessonPool(state, data) {
    return (state.lesson_pool = []);
  },
  clearResource(state, data) {
    return (state.resources = []);
  },
  setTenant(state, data) {
    return (state.tenant = data);
  },
  setTenantPrograms(state, data) {
    return (state.tenant_programs = data);
  },
  setLearnerSurvey(state, data) {
    return (state.surveyLearners = data);
  },
  addTenantProgram(state, data) {
    return (state.tenant_programs = state.tenant_programs.concat(data));
  },
  setTenantProgram(state, data) {
    return (state.tenant_program = data);
  },
  setTenantCourses(state, data) {
    return (state.tenant_courses = data);
  },
  setTenantTestimonials(state, data) {
    return (state.tenant_testimonials = data);
  },
  setTenantDraftedCourses(state, data) {
    return (state.drafted_courses = data);
  },
  addTenantCourse(state, data) {
    return (state.tenant_courses = state.tenant_courses.concat(data));
  },
  setTenantCourse(state, data) {
    return (state.tenant_course = data);
  },
  setTenantModules(state, data) {
    return (state.tenant_modules = data);
  },
  addTenantModule(state, data) {
    return (state.tenant_modules = state.tenant_modules.concat(data));
  },
  setTenantModule(state, data) {
    return (state.tenant_module = data);
  },
  setTenantLessons(state, data) {
    return (state.tenant_lessons = data);
  },
  addTenantLesson(state, data) {
    return (state.tenant_lessons = state.tenant_lessons.concat(data));
  },
  setTenantLesson(state, data) {
    return (state.tenant_lesson = data);
  },
  setTenantArticle(state, data) {
    return (state.tenant_article = data);
  },
  setTenantModuleLessons(state, data) {
    return (state.tenant_module_lessons = data);
  },
  setLessonPool(state, data) {
    return (state.lesson_pool = data);
  },
  setQuizzez(state, data) {
    return (state.quizzes = data);
  },
  setExercise(state, data) {
    return (state.exercises = data);
  },
  setSurvey(state, data) {
    return (state.surveys = data);
  },
  setQuizResults(state, data) {
    return (state.quizResults = data);
  },
  setGamifications(state, data) {
    return (state.gamifications = data);
  },
  setTenantLabels(state, data) {
    return (state.tenantLabels = data);
  },
  setSingleTenantLabel(state, data) {
    return (state.tenantLabel = data);
  },
  setTenantLearners(state, data) {
    return (state.tenant_learners = data)
  },
  updateCurrentPage(state,data) {
    state.supportCurrentPage = data
  }
};
const actions = {
     // async getSingleTenantSettings({})
  async fetchTenantSettings({ commit }, payload) {
    // console.log(payload)
    let res = await Api.get(`/login-page-settings?uri=${payload.prefix}`);
    if (res.status == 200) {
      commit("setThemeColor", res.data.data.data.color_theme);
      commit("loadSettings", res.data.data.data);
      return true;
    } else {
      return res;
    }
  },
  async tenantDeleteBadge({}, payload) {
    let res = await Api.delete(
      `/tenant/reward/badge/${payload.id}/delete`,
      true
    );
    return res;
  },

  async tenantDeleteReward({}, payload) {
    let res = await Api.delete(`/tenant/reward/${payload.id}/delete`, true);
    return res;
  },
  async tenantEditReward({}, payload) {
    let res = await Api.get(`/tenant/reward/${payload.id}/single`, true);
    return res;
  },
  async tenantUpdateReward({}, payload) {
    let res = await Api.put(
      `tenant/reward/${payload.id}/update`,
      payload,
      true
    );
    return res;
  },
  async tenantCreateLeaderboard({}, payload) {
    let res = await Api.post(`tenant/reward/leaderboard/create`, payload, true);
    return res;
  },
  async tenantEditLeaderboard({}, payload) {
    let res = await Api.get(
      `tenant/reward/leaderboard/${payload.id}/single`,
      true
    );
    return res;
  },
  async tenantUpdateLeaderboard({}, payload) {
    let res = await Api.put(
      `tenant/reward/leaderboard/${payload.id}/update`,
      payload,
      true
    );
    return res;
  },
  async tenantDeleteLeaderboard({}, payload) {
    let res = await Api.delete(
      `tenant/reward/leaderboard/${payload.id}/delete`,
      true
    );
    return res;
  },
  async tenantFetchLeaderboard({}) {
    let res = await Api.get(`tenant/reward/leaderboards`, true);
    return res;
  },
  async tenantFetchAllRewards({}) {
    let res = await Api.get(`tenant/reward/all`, true);
    return res;
  },
  async tenantCreateReward({}, payload) {
    let res = await Api.post(`tenant/reward/create`, payload, true);
    return res;
  },
  async tenantFetchAllGradable({}, payload) {
    let res = await Api.get(`tenant/grade/gradable/fetch`, true);
    return res;
  },
  async tenantCreateGradable({}, payload) {
    let res = await Api.post(`tenant/grade/gradable/create`, payload, true);
    return res;
  },
  async tenantAllBadges({}) {
    let res = await Api.get(`/tenant/reward/badges`, true);
    return res;
  },
  async tenantCreateBadge({}, payload) {
    let res = await Api.post(`tenant/reward/badge/create`, payload, true);
    return res;
  },
  async tenantCreateInstructor({}, payload) {
    let res = await Api.post(
      `tenant/course/instructor/new/create`,
      payload,
      true
    );
    return res;
  },
  async tenantAllInstructors({}) {
    let res = await Api.get(`/tenant/course/instructor/list`, true);
    return res;
  },

  async tenantAllPrequisites({}) {
    let res = await Api.get(`/tenant/course/prerequisite/all`, true);
    return res;
  },

  async tenantLessonsInCourse({}, payload) {
    let res = await Api.get(`/tenant/lesson/list?course=${payload.id}`, true);
    return res;
  },

  async tenantEditInstructor({}, payload) {
    let res = await Api.get(
      `tenant/course/instructor/single/${payload.id}/show`,
      true
    );
    return res;
  },

  async tenantDeleteInstructor({}, payload) {
    let res = await Api.delete(`/tenant/course/instructor/${payload.id}`, true);
    return res;
  },

  async tenantDeletePrerequisite({}, payload) {
    let res = await Api.delete(
      `/tenant/course/prerequisite/delete/${payload.id}`,
      true
    );
    return res;
  },

  async tenantUpdateInstructor({}, payload) {
    let res = await Api.put(
      `tenant/course/instructor/update-instructor/${payload.id}`,
      payload,
      true
    );
    return res;
  },

  async tenantUpdateBadge({}, payload) {
    let res = await Api.patch(
      `tenant/reward/badge/${payload.id}/update`,
      payload,
      true
    );
    return res;
  },
  async tenantEditBadge({}, payload) {
    let res = await Api.get(`tenant/reward/badge/${payload.id}/single`, true);
    return res;
  },

  async tenantUpdateCoupon({}, payload) {
    let res = await Api.put(
      `tenant/coupon/${payload.id}/update`,
      payload,
      true
    );
    return res;
  },
  async tenantGetLearner({}, payload) {
    let res = await Api.get(`tenant/user/${payload.id}`, true);
    return res.data.data.learner;
  },
  async tenantListUsers({ commit }, payload) {
    localStorage.setItem("use-backup-api", "true");
    //console.log(payload);
    if (typeof payload !== 'undefined') {
      let res = await Api.get(`tenant/user?page=${payload.page}`, true);
      if (res.data.data.learners.data) {
         commit("setTenantLearners", res.data.data.learners)
      }
      localStorage.setItem("use-backup-api", "false");
      return res.data.data.learners;
    }
    else {
       let res = await Api.get(`tenant/user`, true);
       commit("setTenantLearners", res.data.data.learners)
       localStorage.setItem("use-backup-api", "false");
      return res.data.data.learners;
    }
  },
  async tenantCreateUser({}, payload) {
    localStorage.setItem("use-backup-api", "true");
    let res = await Api.post(`tenant/user/create`, payload, true);
    localStorage.setItem("use-backup-api", "false");
    return res;
  },
  async tenantUpdateUser({}, payload) {
    let { data, id } = payload;
    let res = await Api.put(`tenant/user/${id}`, data, true);
    return res;
  },

  async tenantDeleteUser({}, payload) {
    let { id } = payload;
    let res = await Api.delete(`tenant/user/${id}`, true);
    return res;
  },
  async tenantUpdateSettings({ commit }, payload) {
    let res = await Api.put(`/tenant/settings/update`, payload, true);
    commit("loadSettings", res.data.data.settings);
    return res;
  },
  async tenantGetExercise({}, payload) {
    let res = await Api.get(`tenant/exercise/${payload.id}/fetch`, true);
    return res.data.data.exercise;
  },
  async tenantDeleteSurvey({}, payload) {
    let res = await Api.delete(`tenant/survey/${payload.id}`, true);
    return res;
  },
  async tenantRemoveSurveyQuestion({}, payload) {
    // let res = await Api.delete(`tenant/survey/question/${payload.id}`, true);
    // //console.log(res)
  },
  async tenantUpdateSurvey({}, payload) {
    let res = await Api.put(
      `tenant/survey/${payload.id}`,
      payload.survey,
      true
    );
    return res;
  },
  async tenantSingleSurvey({ commit }, payload) {
    let res = await Api.get(`tenant/survey/single/${payload.id}`, true);
    return res.data.data.survey;
  },
  async tenantSingleSurveySummary({ commit }, payload) {
    let res = await Api.get(`tenant/survey/summary/${payload.id}`, true);
    return res.data.data.survey_summary;
  },
  async tenantSingleSurveyUsers({ commit }, payload) {
    let res = await Api.get(`tenant/survey/users/${payload.id}`, true);
    return res.data.data.learners;
  },
  async tenantSingleSurveyUserAnswer({ commit }, payload) {
    // console.log({ payload });
    let res = await Api.get(
      `tenant/survey/user/${payload.survey_id}/${payload.learner_id}`,
      true
    );
    return res.data.data.survey_answers;
  },
  async tenantDeleteArticle({ commit }, payload) {
    let res = await Api.delete(`tenant/article/${payload.id}`, true);
    return res;
  },

  async tenantDeleteExercise({ commit }, payload) {
    let res = await Api.delete(`tenant/exercise/${payload.id}/delete`, true);
    return res;
  },
  async tenantEditArticle({ commit }, payload) {
    let res = await Api.put(`tenant/article/${payload.id}`, payload, true);
    return res;
  },
  async tenantGetArticle({ commit }, payload) {
    let res = await Api.get(`tenant/article/single/${payload.id}`, true);
    return res.data.data;
  },
  async tenantDeleteLesson({ commit }, payload) {
    let res = await Api.delete(`tenant/lesson/${payload.id}`, true);
    return res;
  },
  async tenantUpdateLesson({ commit }, payload) {
    let res = await Api.put(
      `tenant/lesson/${payload.lesson.id}/update`,
      payload.lesson,
      true
    );
    return res;
  },
  async tenantEditLesson({ commit }, payload) {
    let res = await Api.get(`tenant/lesson/${payload.id}/show`, true);
    return res.data.data.lesson;
  },
  async tenantFetchSurveys({ commit }, payload) {
    commit("clearResource", "");
    let res = await Api.get(`tenant/survey`, true);
    commit("setSurvey", res.data.data.surveys);
    let surveys = res.data.data.surveys;
    surveys.forEach((survey) => {
      let obj = {};
      obj.text = survey.title;
      obj.value = survey.id;
      commit("addResource", obj);
    });
    return true;
  },
  async tenantCreateSurvey({ commit }, payload) {
    let res = await Api.post(`tenant/survey`, payload, true);
    if (res.status == 201) {
      return true;
    } else {
      return res;
    }
  },
  async tenantEditProgram({ commit }, payload) {
    //
  },
  async tenantDeleteModule({ commit }, payload) {
    let res = await Api.delete(`tenant/module/${payload.id}`, true);
    //console.log(res);
    return res;
  },
  async tenantEditModule({ commit }, payload) {
    let res = await Api.get(`/tenant/module/${payload.id}/show`, true);
    return res.data.data.module;
  },
  async tenantUpdateModule({ commit }, payload) {
    let res = await Api.put(
      `tenant/module/${payload.id}/update`,
      payload.module,
      true
    );
    return res;
  },
  async fetchTenants({ commit }) {
    let res = await Api.get("/tenant/all", true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenants", res.data.data.tenant);
      return true;
    } else {
      return res;
    }
  },
  async fetchSingleTenant({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/single/${id}`, true);
    // return res.data.data.tenant;
    if (res.status === 200 || res.status === 201) {
      // //console.log({ jojojoj: res.data.data });
      commit("setTenant", res.data.data.tenant);
      return res.data.data.tenant;
    } else {
      return res;
    }
  },
  async tenantCreateProgram({ commit }, payload) {
    let res = await Api.post(`tenant/program`, payload, true);
    if (res.status === 200 || res.status === 201) {
      commit("addTenantProgram", res.data.data.program);
      return true;
    } else {
      return res;
    }
  },
  async fetchTenantPrograms({ commit }) {
    let res = await Api.get("/tenant/program", true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantPrograms", res.data.data.programs);
      return true;
    } else {
      return res;
    }
  },
  async editTenantProgram({}, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/program/single/${id}`, true);
    return res.data.data.program;
  },
  async updateTenantProgram({}, payload) {
    let res = await Api.put(`tenant/program/${payload.id}`, payload, true);
    return res;
  },
  async deleteTenantProgram({}, payload) {
    let res = await Api.delete(`/tenant/program/${payload.id}`, true);
    return res;
  },
  async fetchSingleTenantProgram({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/program/single/${id}`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantProgram", res.data.data.tenant);
      return true;
    } else {
      return res;
    }
  },
  async editTenantCourse({}, payload) {
    let res = await Api.get(`/tenant/course/${payload.id}/show`, true);
    return res.data;
  },

  async fetchPrerequisite({}, payload) {
    let res = await Api.get(
      `/tenant/course/prerequisite/single/${payload.id}`,
      true
    );
    return res.data;
  },

  async updateTenantCourse({}, payload) {
    payload.skills_to_be_acquired = "programming, development and art &design";
    let res = await Api.put(
      `/tenant/course/${payload.id}/update`,
      payload.course,
      true
    );
    return res;
  },
  async deleteTenantCourse({ dispatch }, payload) {
    let res = await Api.delete(`/tenant/course/${payload.id}/delete`, true);
    dispatch("fetchTenantCourses");
    return res;
  },

  async tenantCreateCourse({ commit }, payload) {
    let { course, id } = payload;
    // course.skills_to_be_acquired = "programming, development and art &design";
    let res = await Api.post(`/tenant/course/${id}/create`, course, true);
    if (res.status === 200 || res.status === 201) {
      commit("addTenantCourse", res.data.data.course);
      return true;
    } else {
      return res;
    }
  },
  async tenantCreateGrowthPlan({ commit }, payload) {
    let res = await Api.post(`/tenant/growth_plan/create`, payload, true);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async tenantCreateCoupon({ commit }, payload) {
    let res = await Api.post(`/tenant/coupon/create`, payload, true);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async tenantUpdateGrowthPlan({ commit }, payload) {
    let { data, id } = payload;
    let res = await Api.put(`/tenant/growth_plan/${id}/update`, data, true);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async tenantDeleteGrowthPlan({ commit }, payload) {
    let res = await Api.delete(
      `/tenant/growth_plan/${payload.id}/delete`,
      true
    );
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async tenantDeleteCourseCoupon({ commit }, payload) {
    let res = await Api.delete(`/tenant/coupon/${payload.id}/delete`, true);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async tenantFetchGrowthPlans({ commit }, payload) {
    commit("clearResource", []);
    let res = await Api.get("/tenant/growth_plan/all", true);
    if (res.status === 200 || res.status === 201) {
      commit("setGrowthPlans", res.data.data.growth_plans);
      let plans = res.data.data.growth_plans;
      //console.log({ plans });
      plans.forEach((plan) => {
        let obj = {};
        if (plan.prompt_type === "embed") {
          obj.text = plan.title;
          obj.value = plan.id;
          commit("addResource", obj);
        }
      });
    }
  },

  async tenantFetchCourseCoupons({ commit }, payload) {
    let res = await Api.get("/tenant/coupon/all", true);
    if (res.status === 200 || res.status === 201) {
      let coupons = res.data.data.coupons;
      //console.log({ coupons });
      return coupons;
    } else {
      return res;
    }
  },

  async tenantFetchGrowthPlan({ commit }, payload) {
    let res = await Api.get(`/tenant/growth_plan/single/${payload.id}`, true);
    if (res.status === 200 || res.status === 201) {
      return res.data.data.growth_plan;
    } else {
      return res;
    }
  },

  async tenantFetchCourseCoupon({ commit }, payload) {
    let res = await Api.get(`/tenant/coupon/single/${payload.id}`, true);
    if (res.status === 200 || res.status === 201) {
      return res.data.data.coupon;
    } else {
      return res;
    }
  },

  async fetchTenantCourses({ commit }, payload) {
    let url = "/tenant/course/list";
    let res = await Api.get(url, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantCourses", res.data.data.data.courses);
      return true;
    } else {
      return res;
    }
  },

  async fetchTenantTestimonials({ commit }, payload) {
    let url = `tenant/learner/testimonial`;
    let res = await Api.get(url, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantTestimonials", res.data.data.testimonials);
      return true;
    } else {
      return res;
    }
  },

  async fetchTenantDraftedCourses({ commit }, payload) {
    let url = "/tenant/course/drafted/list";
    let res = await Api.get(url, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantDraftedCourses", res.data.data.data.courses);
      return true;
    } else {
      return res;
    }
  },

  async fetchCoursesInProgram({ commit }, payload) {
    let res = await Api.get(`tenant/course/list?program=${payload.id}`, true);
    if (res.status === 200 || res.status === 201) {
      return res.data.data.data.courses;
    } else {
      return res;
    }
  },

  async fetchSingleTenantCourse({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/course/${id}/show`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantCourse", res.data.data.course);
      return true;
    } else {
      return res;
    }
  },

  async fetchCourseEnrolles({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/course/${id}/enrollees`, true);
    if (res.status === 200 || res.status === 201) {
      return res.data.data.enrollees;
    } else {
      return res;
    }
  },

  async tenantCreateModule({ commit }, payload) {
    let { module, id } = payload;
    module.skills_gained = "skills";
    let res = await Api.post(`/tenant/module/${id}/create`, module, true);
    if (res.status === 200 || res.status === 201) {
      commit("addTenantModule", res.data.data.module);
      return true;
    } else {
      return res;
    }
  },
  async loadUserAssets({ commit }, payload) {
    let res = await Api.get(`tenant/asset/fetch`, true);
    commit("clearResource", "");
    let assets = res.data.data.assets;
    assets.forEach((asset) => {
      let obj = {};
      obj.text = asset.asset_name;
      obj.value = asset.asset_url;
      commit("addResource", obj);
    });
    return true;
  },
  async tenantFetchGamifications({ commit }) {
    let res = await Api.get(`tenant/games`, true);
    if (res.status === 200) {
      commit("setGamifications", res.data.data.gamifications);
      let ganes = res.data.data.gamifications;
      ganes.forEach((game) => {
        let obj = {};
        obj.text = game.title;
        obj.value = game.id;
        commit("addResource", obj);
      });
      return true;
    }
    return res;
  },
  async loadUserArticles({ commit }, payload) {
    let res = await Api.get(`tenant/article`, true);
    commit("setTenantArticle", res.data.data.articles);
    commit("clearResource", "");
    let articles = res.data.data.articles;
    articles.forEach((article) => {
      let obj = {};
      obj.text = article.title;
      obj.value = article.id;
      commit("addResource", obj);
    });
    return true;
  },
  async fetchTenantModules({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/module/${id}/list`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantModules", res.data.data.data.modules);
      return true;
    } else {
      return res;
    }
  },

  async fetchTenantLessons({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/lesson/list?course=${id}`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantLessons", res.data.data.lessons);
      return true;
    } else {
      return res;
    }
  },
  async fetchSingleTenantModule({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/module/${id}/show`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantModule", res.data.data.module);
    }
    return res;
  },
  async tenantCreateLesson({ state }, payload) {
    let { lesson, course, program, module } = payload;
    lesson.skills_gained = lesson.skills_gained ? lesson.skills_gained : "";
    let res = await Api.post(
      `/tenant/lesson/${program}/${course}/${module}/create`,
      lesson,
      true
    );
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },
  // async fetchTenantModules({ commit }, payload) {
  //   let { id } = payload;
  //   let res = await Api.get(`/tenant/module/${id}/list`, true);
  //   if (res.status === 200 || res.status === 201) {
  //     commit("setTenantModules", res.data.data.data.modules);
  //     return true;
  //   } else {
  //     return res;
  //   }
  // },
  async fetchTenantModuleLessons({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/lesson/list?module=${id}`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantModuleLessons", res.data.data.data.lessons.data);
      return true;
    } else {
      return res;
    }
  },
  async tenantCreateAsset({ commit }, payload) {
    let res = await Api.post(`/tenant/asset/upload`, payload, true);
    if (res.status === 200 || res.status === 201) {
      // commit("setTenantAsset", res.data.data.module);
      return true;
    } else {
      return res;
    }
  },
  async fetchTenantAssets({ commit }) {
    let res = await Api.get(`/tenant/asset/fetch`, true);
    if (res.status === 200 || res.status === 201) {
      //console.log({ resfff: res.data.data.assets });
      commit("setTenantAsset", res.data.data.assets);
      return true;
    } else {
      return res;
    }
  },
  async fetchAdminPool({ commit }) {
    let res = await Api.get(`/tenant/lesson/fetch-from-pool`, true);
    commit("clearLessonPool", "");
    if (res.status === 200 || res.status === 201) {
      let lessons = res.data.data.data.lessons.data;
      lessons.forEach((lesson) => {
        let obj = {};
        obj.text = lesson.title;
        obj.value = lesson.lesson_resource;
        commit("addLessonPool", obj);
      });
    } else {
      return res;
    }
  },
  async deleteTenantAsset({}, payload) {
    let res = await Api.delete(`/tenant/asset/${payload.id}/delete`, true);
    return res;
  },
  async createTenantArticle({}, payload) {
    let res = await Api.post(`tenant/article`, payload, true);
    return res;
  },
  async tenantCreateQuiz({}, payload) {
    let res = await Api.post(`tenant/quiz/create`, payload, true);
    return res;
  },
  async tenantUpdateQuiz({}, payload) {
    let res = await Api.put(`tenant/quiz/${payload.id}/update`, payload, true);
    return res;
  },
  async tenantFetchQuiz({ commit }, payload) {
    let res = await Api.get(`tenant/quiz/fetch-all`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setQuizzez", res.data.data.quizzes);
      return true;
    } else {
      return res;
    }
  },

  async tenantDeleteQuiz({ commit }, payload) {
    let res = await Api.delete(`tenant/quiz/${payload.id}/delete`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setQuizzez", res.data.data.quizzes);
      return res;
    } else {
      return res;
    }
  },

  async tenantFetchSingleQuiz({ commit }, payload) {
    let res = await Api.get(`tenant/quiz/${payload.id}/fetch`, true);
    return res;
  },

  async tenantFetchQuizResult({ commit }, payload) {
    let res = await Api.get(`tenant/lesson/quiz-reports`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setQuizResults", res.data.data.results);
      return true;
    } else {
      return res;
    }
  },
  async tenantFetchSurveyResult({ commit }, payload) {
    let res = await Api.get(`tenant/survey/users/${payload.id}`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setLearnerSurvey", res.data.learners);
      return true;
    } else {
      return res;
    }
  },
  async tenantFetchQuizForLesson({ commit }, payload) {
    let res = await Api.get(`tenant/quiz/fetch-all`, true);
    if (res.status === 200 || res.status === 201) {
      let quizzes = res.data.data.quizzes;
      quizzes.forEach((quiz) => {
        let obj = {};
        obj.text = quiz.title;
        obj.value = quiz.id;
        commit("addResource", obj);
      });
      return true;
    } else {
      return res;
    }
  },

  async tenantFetchExerciseForLesson({ commit }, payload) {
    let res = await Api.get(`tenant/exercise/fetch-all`, true);
    if (res.status === 200 || res.status === 201) {
      let exercises = res.data.data.exercises;
      exercises.forEach((exercise) => {
        let obj = {};
        obj.text = exercise.title;
        obj.value = exercise.id;
        commit("addResource", obj);
      });
      return true;
    } else {
      return res;
    }
  },
  async tenantCreateExercise({}, payload) {
    let res = await Api.post(`tenant/exercise/create`, payload, true);
    return res;
  },

  async tenantUpdateExercise({}, payload) {
    let res = await Api.put(
      `tenant/exercise/${payload.exercise_id}/update`,
      payload,
      true
    );
    return res;
  },
  async tenantFetchExercise({ commit }, payload) {
    let res = await Api.get(`tenant/exercise/fetch-all`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setExercise", res.data.data.exercises);
      return true;
    } else {
      return res;
    }
  },

  async tenantFetchTasks({ commit }, payload) {
    let res = await Api.get(`tenant/grade/tasks/list`, true);
    if (res.status === 200 || res.status === 201) {
      return res.data.data.list;
    } else {
      return res;
    }
  },

  async tenantFetchTask({ commit }, payload) {
    let res = await Api.get(`/tenant/grade/tasks/${payload.id}/single`, true);
    if (res.status === 200 || res.status === 201) {
      return res.data.data.grade;
    } else {
      return res;
    }
  },

  async tenantScoreTask({ commit }, payload) {
    let res = await Api.post(
      `/admin/tasks/${payload.id}/submit`,
      { score: payload.score },
      true
    );
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async getWebinar({}, payload) {
    let res = await Api.get(`/tenant/webinar/${payload.id}`, true);
    //console.log({ ressss: res });
    return res.data;
  },

  async getWebinars({}, payload) {
    let res = await Api.get(`/tenant/webinar`, true);
    //console.log({ ressss: res });
    return res.data.data.webinar;
  },
  async updateWebinar({ commit }, payload) {
    let res = await Api.put(`/tenant/webinar/${payload.id}`, payload, true);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },
  async deleteWebinar({ dispatch }, payload) {
    let res = await Api.delete(`/tenant/webinar/${payload.id}`, true);
    return res;
  },
  async createWebinar({ commit }, payload) {
    let res = await Api.post(`/tenant/webinar`, payload, true);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async tenantAllCertificates({}) {
    let res = await Api.get(`/tenant/certificate/fetch`, true);
    return res;
  },

  async tenantEditCertificate({}, payload) {
    let res = await Api.get(`tenant/certificate/${payload.id}/single`, true);
    return res;
  },

  async tenantDeleteCertificate({}, payload) {
    let res = await Api.delete(
      `/tenant/certificate/${payload.id}/delete`,
      true
    );
    return res;
  },

  async tenantUpdateCertificate({}, payload) {
    // console.log(payload)
    let res = await Api.patch(
      `tenant/certificate/${payload.id}/update`,
      payload,
      true
    );
    return res;
  },

  async tenantCreateCertificate({}, payload) {
    let res = await Api.post(`tenant/certificate`, payload, true);
    return res;
  },

  async tenantCreatePrerequiste({}, payload) {
    let res = await Api.post(
      `tenant/course/prerequisite/update`,
      payload,
      true
    );
    return res;
  },

  async fetchDashboardData({}, payload) {
    let res = await Api.get(`tenant/dashboard`, true);
    return res.data.data.data;
  },

  async tenantSendCertificate({}, payload) {
    let res = await Api.post(
      `tenant/course/certificate/${payload.course}/${payload.learner}/send`,
      {},
      true
    );
    return res;
  },

  async sendMessage({}, payload) {
    let res = await Api.post(
      `tenant/discussion/${payload.id}`,
      { message: payload.message },
      true
    );
    return res;
  },

  async sendReply({}, payload) {
    let res = await Api.post(
      `tenant/discussion/${payload.id}/reply`,
      { message: payload.message },
      true
    );
    return res;
  },
  async submitLabel({}, payload) {
    let res = await Api.post(
        `tenant/label/create`, payload,
        true
    );
    return res;
  },
  async fetchLabels({commit}, payload) {
    let url =  typeof payload !==  "undefined" ? `tenant/label/fetch-all?type=${payload.type}` : `tenant/label/fetch-all`
    let res = await Api.get(
       url,
        true
    );
    commit("setTenantLabels",res.data.data.labels)
    return res;
  },

  async fetchSingleLabel({commit}, payload) {
    let res = await Api.get(
        `tenant/label/${payload.id}/fetch`,
        true
    );
    commit("setSingleTenantLabel",res.data.data.label)
    return res.data.data.label
  },
  async updateLabel({commit}, payload) {
    let { data, id } = payload;
    return await Api.put(
        `tenant/label/${id}/update`, data,
        true
    );
  },

  async tenantUpdateCourseReminder({commit},payload){
    return await Api.put(
      `tenant/course/reminder-config/${payload.id}/update`,payload,true
    );
  },

  async tenantFetchSingleCourseReminder({commit},payload){
    return await Api.get(
      `tenant/course/reminder-config/${payload.id}/fetch`,true
    );
  },


  async tenantUpdateProgramReminder({commit},payload){
    return await Api.put(
      `tenant/program/reminder-config/${payload.id}/update`,payload,true
    );
  },

  async tenantFetchSingleProgramReminder({commit},payload){
    return await Api.get(
      `tenant/program/reminder-config/${payload.id}/fetch`,true
    );
  },

  async removeCourseConfig({commit},payload){
    return await Api.delete( `reminder-config/{course_config}/delete`)
  },

  async getTenantAnalytics({commit}){
    return await Api.get('tenant/overall-analysis',true);
  },

  async getTenantPerformance({commit},payload){
    return await Api.get(`tenant/performance/${payload.id}`,true);
  },

  async getOverallStats({commit},payload){
    return await Api.get(`tenant/course-stats/${payload.id}?page=${payload.page}`,true);
  },
  async learnerNotLearning({commit},payload){
    return await Api.get(`tenant/support?search=${payload.search}&page=${payload.page}&status=${payload.status}&issue_treat=${payload.issue_treat}&active_status=${payload.active_status}&course=${payload.course}&cohort=${payload.cohort}&network=${payload.network}&treatment_level=${payload.treatment_level}&course_type=${payload.course_type}`,true);
  },
  async learnerNotLearningStatus({commit},payload){
    return await Api.get(`tenant/support?search=${payload.search}`,true);
  },
  async fetchGiftingHistory({commit},payload){
    return await Api.get(`tenant/gifting-history?page=${payload.page}&performed=${payload.performed}&mode=${payload.mode}&weekly=${payload.weekly}`,true);
  },
  async logReport({commit},payload){
    return await Api.post(`tenant/report-log`,payload,true);
  },
  async getReportLog({commit},payload){
    return await Api.get(`tenant/log?id=${payload.user_id}&error_type=${payload.error_type}`,true);
  },
  async logStatus({commit},payload){
    return await Api.put(`tenant/log-status`,payload,true);
  },
  async credential({commit},payload){
    return await Api.post('tenant/credentials',payload,true);
  },
  async customEmailMessage({commit},payload){
    return await Api.post('tenant/custom-email-message',payload,true);
  },

  async manualGifting({commit},payload){
    return await Api.post('tenant/manual/gifting',payload,true);
  },
  async sendLearnerCertificate({commit},payload){
    return await Api.post('tenant/send-learner-certificate',payload,true);
  },
  async fetchGrowthPlanQualifier({commit}, payload){
    return await Api.get(`tenant/growth-plan-qualifier?page=${payload.page}&search=${payload.search}&start_time=${payload.start_time}&end_time=${payload.end_time}`,true);
  },
  async fetchCourseCompletionQualifier({commit}, payload){
    return await Api.get(`tenant/course-completion-qualifier?page=${payload.page}&search=${payload.search}&start_time=${payload.start_time}&end_time=${payload.end_time}`,true);
  },

  async email({commit},payload){
    return await Api.post('tenant/send-mail',payload,true);
  },

  async telegram({commit},payload){
    return await Api.post('tenant/send-telegram-invite',payload,true);
  },

  async sms({commit},payload){
    return await Api.post('tenant/send-sms',payload,true);
  },

  async learnerLessons({commit},payload){
    return await Api.get(`tenant/learner-lessons`,true);
  },
  async lessonStat({commit},payload){

    return await Api.get(`tenant/lesson-stat?course=${payload.course}&page=${payload.page}`,true);
  },
  async completionTracker({commit},payload){
    //console.log(payload)
    return await Api.get(`tenant/completion-tracker-count?compulsory_count=${payload.compulsory_count}&elective_count=${payload.elective_count}&page=${payload.page}`,true);
  },
  async generateSso({commit},payload) {
    return await Api.post('tenant/generate-link',payload,true);
  },
  async fetchAllCompletedLearner({commit},payload) {
    return await Api.get(`tenant/fetch-learner/completed?page=${payload.page}`,true);
  },
  async fetchLearnerhistory({commit},payload) {
    return await Api.post(`tenant/learner-course-history`,payload,true);
  },
  async fetchLearnerDataIvr({commit},payload) {
    return await Api.post(`tenant/learner-data-ivr-history`,payload,true);
  },
  async downloadLearnercsv({commit},payload){
    if(payload.status === '' || payload.status === 'all'){
      const res = await Api.get(`download-learner`,true);
      // console.log(res)
      window.open(res.data, "_blank");
    } else if(payload.status === 'not-treated'){
      const res = await Api.get(`download-nottreated-learners`,true);
      window.open(res.data, "_blank");
    } else if(payload.status === 'treated'){
      const res = await Api.get(`download-treated-learners`,true);
      window.open(res.data, "_blank");
    }
  }

};

export default {
  state,
  getters,
  mutations,
  actions,
};
